import { Box, Grid } from "@mui/material";
import { Fragment } from "react";
import ExpandableGrid from "./ExpandableGrid";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { SimpleDataTable } from "./SimpleDataTable";

interface Props {
  defaultOpen: boolean;
  title: React.ReactNode;
  tableData: {
    [rowName: string]: string | number;
  };
}

export default (props: Props) => {
  return (
    <Fragment>
      <ExpandableGrid
        defaultOpen={props.defaultOpen}
        content={(isOpen) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              pl: 1,
            }}
          >
            {props.title}
            {isOpen ? (
              <ExpandLess fontSize="large" />
            ) : (
              <ExpandMore fontSize="large" />
            )}
          </Box>
        )}
      >
        <Grid size={{ md: 12, xl: 12 }}>
          <Box sx={{ p: 1 }}>
            <SimpleDataTable tableData={props.tableData} />
          </Box>
        </Grid>
      </ExpandableGrid>
    </Fragment>
  );
};
